<script lang="ts">
	import { t, type Language } from '$lib/i18n';
	import Logo from './Logo.svelte';

	interface Props {
		lang: Language;
	}

	let { lang }: Props = $props();
	let tr = $derived(t(lang));

	const currentYear = new Date().getFullYear();
</script>

<footer class="site-footer bg-[var(--footer-bg)] border-t border-[var(--border)]">
	<div class="max-w-7xl mx-auto px-6 py-16">
		<div class="grid grid-cols-1 md:grid-cols-4 gap-12">
			<!-- Brand -->
			<div class="md:col-span-2">
				<a href="/{lang}" class="flex items-center mb-4 text-[#EEEFE3]" aria-label="Ameta home">
					<Logo size="lg" class="footer-logo" />
				</a>
				<p class="text-[var(--text-secondary)] max-w-md leading-relaxed">
					{tr('footer_description')}
				</p>
			</div>

			<!-- Quick links -->
			<div>
				<p class="text-[var(--text-primary)] font-semibold mb-4">{tr('footer_quicklinks')}</p>
				<ul class="space-y-3">
					<li>
						<a
							href="/{lang}/services"
							class="text-[var(--text-secondary)] hover:text-ameta-green transition-colors"
							>{tr('nav_services')}</a
						>
					</li>
					<li>
						<a
							href="/{lang}/analytics"
							class="text-[var(--text-secondary)] hover:text-ameta-green transition-colors"
							>{tr('nav_platform')}</a
						>
					</li>
					<li>
						<a
							href="/{lang}/about"
							class="text-[var(--text-secondary)] hover:text-ameta-green transition-colors"
							>{tr('nav_about')}</a
						>
					</li>
					<li>
						<a
							href="/{lang}/#contact"
							class="text-[var(--text-secondary)] hover:text-ameta-green transition-colors"
							>{tr('nav_contact')}</a
						>
					</li>
					<li>
						<a
							href="/{lang}/privacy"
							class="text-[var(--text-secondary)] hover:text-ameta-green transition-colors"
							>{tr('footer_privacy')}</a
						>
					</li>
				</ul>
			</div>

			<!-- Contact -->
			<div>
				<p class="text-[var(--text-primary)] font-semibold mb-4">{tr('footer_contact')}</p>
				<ul class="space-y-3 text-[var(--text-secondary)]">
					<li>
						<a href="mailto:hello@ameta.no" class="hover:text-ameta-green transition-colors">
							hello@ameta.no
						</a>
					</li>
					<li>Kjøita 40</li>
					<li>4630 Kristiansand</li>
					<li>Norway</li>
				</ul>
			</div>
		</div>

		<!-- Keyboard shortcuts -->
		<div
			class="mt-12 pt-8 border-t border-[var(--border)] flex flex-wrap justify-center gap-4 text-xs text-[var(--text-muted)]"
		>
			<span class="flex items-center gap-1.5">
				<kbd
					class="px-1.5 py-0.5 rounded bg-slate-800 border border-slate-700 font-mono text-slate-300"
					>⌘K</kbd
				>
				{tr('footer_shortcut_palette')}
			</span>
			<span class="hidden md:flex items-center gap-1.5">
				<kbd
					class="px-1.5 py-0.5 rounded bg-slate-800 border border-slate-700 font-mono text-slate-300"
					>⌘.</kbd
				>
				{tr('footer_shortcut_terminal')}
			</span>
		</div>

		<div
			class="mt-6 pt-6 border-t border-[var(--border)] flex flex-col md:flex-row justify-between items-center gap-4"
		>
			<p class="text-[var(--text-muted)] text-sm">
				&copy; {currentYear} Ameta AS. {tr('footer_copyright')}
			</p>
			<a
				href="https://linkedin.com/company/ameta-no"
				target="_blank"
				rel="noopener noreferrer"
				class="text-[var(--text-muted)] hover:text-ameta-green transition-colors"
				aria-label="LinkedIn"
			>
				<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
					<path
						d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
					/>
				</svg>
			</a>
		</div>
	</div>
</footer>
